import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ExamPreviewComp from "./Component/ExamPreviewComp"


const ExamPreview =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ExamPreviewComp />
        </div>
        <Footer />
        </>
    )
}

export default ExamPreview